import { render, staticRenderFns } from "./TemplateSetting.vue?vue&type=template&id=7e0b8c00&scoped=true&"
import script from "./TemplateSetting.vue?vue&type=script&lang=js&"
export * from "./TemplateSetting.vue?vue&type=script&lang=js&"
import style0 from "./TemplateSetting.vue?vue&type=style&index=0&id=7e0b8c00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0b8c00",
  null
  
)

export default component.exports